import {
  Avatar,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Sizes,
} from '@sede-enterprise/shell-ds-react-framework';
import { useAppUserDetailsFromJwt } from 'common-react/auth/utils/hooks/useAppUserDetailsFromJwt/useAppUserDetailsFromJwt';
import ProfileMenu from 'components/NavBar/ProfileMenu';
import { useDimensions } from 'hooks/useDimensions/useDimensions';
import { useStore } from 'store';

export const UserProfileButton: React.FC<{}> = () => {
  const { isMobile } = useDimensions();

  const { firstName, lastName } = useAppUserDetailsFromJwt();

  const avatarAbbreviation =
    firstName && lastName ? `${firstName?.[0]}${lastName?.[0]}` : '';

  const setMobileProfileOpen = useStore((state) => state.setMobileProfileOpen);

  return isMobile ? (
    <Avatar
      aria-haspopup="true"
      aria-controls="profileMenu"
      id="avatarButton"
      data-testid="profile-avatar-button"
      abbreviation={avatarAbbreviation}
      size={Sizes.Medium}
      style={{
        marginLeft: '0px',
        marginRight: '0px',
      }}
      onClick={setMobileProfileOpen}
    />
  ) : (
    <Popover defaultOpen={false}>
      <PopoverTrigger asChild>
        <div>
          <Avatar
            aria-haspopup="true"
            aria-controls="profileMenu"
            id="avatarButton"
            data-testid="profile-avatar-button"
            abbreviation={avatarAbbreviation}
            size={Sizes.Medium}
            style={{
              paddingLeft: 15,
              paddingRight: 0,
              width: 62,
              cursor: 'pointer',
            }}
          />
        </div>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        style={{
          marginRight: '10px',
          marginTop: '10px',
          zIndex: '100',
          padding: '16px',
        }}
      >
        <ProfileMenu />
      </PopoverContent>
    </Popover>
  );
};
